import React from 'react'
import { Outlet } from 'react-router'
import Header from '../components/Header'

function PublicLayout({ children }) {
    return (
        <div>
            <Header />
            <div className='px-5'>
                <Outlet />
                {children}
            </div>

        </div>
    )
}

export default PublicLayout